var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0788 11.5693H11.0591V10.5496H12.0788V11.5693Z",
    fill: "#FFED00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1182 11.5693H13.0984V10.5496H14.1182V11.5693Z",
    fill: "#FFED00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 12.5889H12.0789V11.5691H13.0986V12.5889Z",
    fill: "#FFED00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 11.5693H12.0789V10.5496H13.0986V11.5693Z",
    fill: "#FFED00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 10.5498H12.0789V9.53009H13.0986V10.5498Z",
    fill: "#FFED00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1182 8.50977H13.0984V7.49005H14.1182V8.50977Z",
    fill: "#FFED00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1182 7.49023H13.0984V6.47052H14.1182V7.49023Z",
    fill: "#FFED00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1182 6.46973H13.0984V5.45001H14.1182V6.46973Z",
    fill: "#FFED00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1182 5.4502H13.0984V4.43048H14.1182V5.4502Z",
    fill: "#FFED00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 4.43066H12.0789V3.41095H13.0986V4.43066Z",
    fill: "#FFED00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9212 4.43066H2.90148V3.41095H3.9212V4.43066Z",
    fill: "#FFED00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94073 4.43066H3.92102V3.41095H4.94073V4.43066Z",
    fill: "#FFED00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96063 4.43066H4.94091V3.41095H5.96063V4.43066Z",
    fill: "#FFED00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98016 4.43066H5.96044V3.41095H6.98016V4.43066Z",
    fill: "#FFED00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98016 11.5693H7.99988V12.5891H6.98016V11.5693Z",
    fill: "#FFED00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96063 11.5693H6.98035V12.5891H5.96063V11.5693Z",
    fill: "#FFED00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94073 11.5693H5.96045V12.5891H4.94073V11.5693Z",
    fill: "#FFED00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9212 11.5693H4.94092V12.5891H3.9212V11.5693Z",
    fill: "#FFED00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0788 4.43066H11.0591V3.41095H12.0788V4.43066Z",
    fill: "#FFED00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0394 3.41113H11.0591V4.43085H10.0394V3.41113Z",
    fill: "#FFED00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 11.5693H10.0396V12.5891H9.01984V11.5693Z",
    fill: "#FFED00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 3.41113H10.0396V4.43085H9.01984V3.41113Z",
    fill: "#FFED00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5693H9.01972V12.5891H8V11.5693Z",
    fill: "#FFED00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9212 12.5889H2.90148V11.5691H3.9212V12.5889Z",
    fill: "#FFED00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 11.5693H1.88165V10.5496H2.90137V11.5693Z",
    fill: "#FFED00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 10.5498H1.88165V9.53009H2.90137V10.5498Z",
    fill: "#FFED00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 9.53027H1.88165V8.51055H2.90137V9.53027Z",
    fill: "#FFED00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 8.50977H1.88165V7.49005H2.90137V8.50977Z",
    fill: "#FFED00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 7.49023H1.88165V6.47052H2.90137V7.49023Z",
    fill: "#FFED00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 6.46973H1.88165V5.45001H2.90137V6.46973Z",
    fill: "#FFED00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90137 5.4502H1.88165V4.43048H2.90137V5.4502Z",
    fill: "#FFED00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.43066H6.98028V3.41095H8V4.43066Z",
    fill: "#FFED00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 4.43066H8.00012V3.41095H9.01984V4.43066Z",
    fill: "#FFED00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 6.46973H12.0789V5.45001H13.0986V6.46973Z",
    fill: "#FFED00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9212 6.46973H2.90148V5.45001H3.9212V6.46973Z",
    fill: "#FFED00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94073 6.46973H3.92102V5.45001H4.94073V6.46973Z",
    fill: "#FFED00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96063 6.46973H4.94091V5.45001H5.96063V6.46973Z",
    fill: "#FFED00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98016 6.46973H5.96044V5.45001H6.98016V6.46973Z",
    fill: "#FFED00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0788 6.46973H11.0591V5.45001H12.0788V6.46973Z",
    fill: "#FFED00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0394 5.4502H11.0591V6.46991H10.0394V5.4502Z",
    fill: "#FFED00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 5.4502H10.0396V6.46991H9.01984V5.4502Z",
    fill: "#FFED00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.46973H6.98028V5.45001H8V6.46973Z",
    fill: "#FFED00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 6.46973H8.00012V5.45001H9.01984V6.46973Z",
    fill: "#FFED00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0986 7.49023H12.0789V6.47052H13.0986V7.49023Z",
    fill: "#FFED00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9212 7.49023H2.90148V6.47052H3.9212V7.49023Z",
    fill: "#FFED00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94073 7.49023H3.92102V6.47052H4.94073V7.49023Z",
    fill: "#FFED00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96063 7.49023H4.94091V6.47052H5.96063V7.49023Z",
    fill: "#FFED00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98016 7.49023H5.96044V6.47052H6.98016V7.49023Z",
    fill: "#FFED00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0788 7.49023H11.0591V6.47052H12.0788V7.49023Z",
    fill: "#FFED00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0394 6.46973H11.0591V7.48945H10.0394V6.46973Z",
    fill: "#FFED00"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 6.46973H10.0396V7.48945H9.01984V6.46973Z",
    fill: "#FFED00"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.49023H6.98028V6.47052H8V7.49023Z",
    fill: "#FFED00"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01984 7.49023H8.00012V6.47052H9.01984V7.49023Z",
    fill: "#FFED00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/add_card.3593c53336f8b10693be10b8aab6b02f.svg";
export { ForwardRef as ReactComponent };